var map = {
	"./char-0.png": 189,
	"./char-1.png": 190,
	"./char-2.png": 191,
	"./char-3.png": 192,
	"./char-4.png": 193,
	"./char-5.png": 194,
	"./char-6.png": 195,
	"./char-7.png": 196,
	"./char-8.png": 197,
	"./char-9.png": 198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 497;